import { GraduationCap, Network, Globe2 } from "lucide-react";
import { CREDIBILITY } from "../../data/marketing";

export default function CredibilityStrip({ compact = false }) {
  return (
    <section className={`bg-forest-deep text-[#FBF9F4] ${compact ? "py-4" : "py-8"}`} data-testid="credibility-strip">
      <div className={`mx-auto grid max-w-7xl px-4 sm:px-6 ${compact ? "gap-3 lg:grid-cols-[1.1fr_1fr_1.35fr] lg:items-center" : "gap-5 lg:grid-cols-[1.1fr_1fr_1.2fr] lg:items-center"}`}>
        <div className="flex items-center gap-3">
          <span className={`flex shrink-0 items-center justify-center rounded-2xl bg-emerald-400/10 text-emerald-300 ${compact ? "h-9 w-9" : "h-11 w-11"}`}>
            <GraduationCap className={compact ? "h-4 w-4" : "h-5 w-5"} />
          </span>
          <p className={`font-display font-bold ${compact ? "text-base" : "text-lg"}`} data-testid="credibility-alumni">{CREDIBILITY[0]}</p>
        </div>
        <div className="flex items-center gap-3">
          <span className={`flex shrink-0 items-center justify-center rounded-2xl bg-emerald-400/10 text-emerald-300 ${compact ? "h-9 w-9" : "h-11 w-11"}`}>
            <Network className={compact ? "h-4 w-4" : "h-5 w-5"} />
          </span>
          <p className={`font-semibold text-emerald-100/85 ${compact ? "text-xs sm:text-sm" : "text-sm"}`} data-testid="credibility-veterans">{CREDIBILITY[1]}</p>
        </div>
        <div className="flex items-center gap-3 lg:justify-end">
          <Globe2 className={`${compact ? "h-4 w-4" : "h-5 w-5"} shrink-0 text-emerald-300`} />
          <p className={`font-mono font-semibold uppercase text-emerald-300/90 ${compact ? "text-[10px] tracking-[0.14em]" : "text-[11px] tracking-[0.18em]"}`} data-testid="credibility-networks">
            {CREDIBILITY[2]}
          </p>
        </div>
      </div>
    </section>
  );
}
